<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-row>
      <b-col>
        <p class="reg-heading-tab mb-3">EMI Schedule</p>
        <b-table
          ref="emiTable"
          show-empty
          head-variant="dark"
          empty-text="No Schedule available."
          stacked="md"
          bordered
          striped
          :items="emiList"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          @row-selected="onRowSelected"
          style="font-size:12px"
        >
          <template v-slot:cell(SL)="row">
            <span aria-hidden="true">{{perPage *(currentPage-1)+row.index+1}}</span>
          </template>
          <template v-slot:cell(selected)="row">
            <b-form-checkbox
              v-if="row.item.IsDue"
              @change="selectClaim($event,row.index, row.item)"
            >EMI Paid</b-form-checkbox>

            <!-- <template v-if="row.rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not Selected</span>
            </template>-->
          </template>
          <template v-slot:custom-foot>
            <b-tr style="background-color:#1a6496;color:#ffffff;font-size:13px;">
              <b-td></b-td>
              <b-td><strong>TOTAL</strong></b-td>
              <b-td><strong>{{ fmtNum(columnTotals.EMIAmount) }}</strong></b-td>
              <b-td></b-td>
              <b-td><strong>{{ fmtNum(columnTotals.PrincipalAmount) }}</strong></b-td>
              <b-td><strong>{{ fmtNum(columnTotals.InterestAmount) }}</strong></b-td>
              <b-td></b-td>
              <b-td></b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row>
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
              <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="5">
        <b-form @submit="onSubmit" @reset="onReset">
          <b-row class="justify-content-md-center">
            <b-col class="mt-2">
              <p class="reg-heading-tab mb-3">Add New Disbursal</p>
              <div class="reg-tab-container mb-3">
                <b-row>
                  <b-col md="3">
                    <b style="font-size:14px">Bank Name:</b>
                  </b-col>
                  <b-col style="font-size:14px">{{LoanDetails.BankName}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b style="font-size:14px">Branch Name:</b>
                  </b-col>
                  <b-col style="font-size:14px">{{LoanDetails.BranchName}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b style="font-size:14px">Approved Amount:</b>
                  </b-col>
                  <b-col>&#8377;{{LoanDetails.SanctionAmount}}</b-col>
                  <b-col md="3">
                    <b style="font-size:14px">Disbursed Amount:</b>
                  </b-col>
                  <b-col md="3">&#8377;{{TotalDisbursementAmount}}</b-col>
                </b-row>
                <b-row>
                  <b-col md="3" style="font-size:14px">
                    <b>Interest Rate %:</b>
                  </b-col>
                  <b-col md="3" style="font-size:14px">{{LoanDetails.ROI}}</b-col>

                  <b-col md="3" style="font-size:14px">
                    <b>Tenure (months):</b>
                  </b-col>
                  <b-col md="3" style="font-size:14px">{{LoanDetails.LoanTenure}}</b-col>
                </b-row>
              </div>
              <div class="reg-tab-container">
                <b-form-group id="igrp0" label="EMI Paid Date*" label-cols="4" label-size="sm">
                  <b-form-input
                    type="date"
                    placeholder="EMI Paid Date"
                    size="sm"
                    required
                    lazy-formatter
                    v-model="form.EMIPaidDate"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="igrp0" label="EMI Paid Amt*" label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="EMI Amount Paid"
                    min="1"
                    step="0.01"
                    size="sm"
                    lazy-formatter
                    required
                    v-model="form.EMIPaidAmt"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="igrp1" label="Principal Amount" label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="Start Date"
                    size="sm"
                    disabled
                    v-model="form.PrincipalAmt"
                  ></b-form-input>
                </b-form-group>
                <b-form-group id="igrp2" label="Interest Amount" label-cols="4" label-size="sm">
                  <b-form-input
                    type="number"
                    placeholder="End Date"
                    size="sm"
                    required
                    v-model="form.InterestAmt"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="igrp3"
                  horizontal
                  label="Other Charges (Rs)*"
                  label-cols="4"
                  label-size="sm"
                  label-for="inpAmount"
                >
                  <b-form-input
                    id="inpAmount"
                    type="number"
                    v-model="form.PenaltyCharges"
                    required
                    size="sm"
                    placeholder="Other Charges Paid"
                  ></b-form-input>
                </b-form-group>
                <div class="row">
                  <div class="col-md-4">
                    <span class="ln-eng" style="font-size: 0.875rem;">EMI Payment Proof *</span>
                    <p
                      style="font-size: 0.75rem;color:#2284ab;"
                    >Upload Bank Statement Showing EMI Payment or Loan Account Statement</p>
                  </div>
                  <div class="col-md-4">
                    <b-form-file
                      ref="fiPhotoPath"
                      @change="onFileChange"
                      v-if="form.UploadEMIPaidProof =='' || !form.UploadEMIPaidProof"
                      accept=".jpg, .png, .gif, .pdf"
                      size="sm"
                      required
                      class="mt-3"
                      plain
                    ></b-form-file>
                    <a v-if="PhotoPreviewUrl && (form.UploadEMIPaidProof =='' || !form.UploadEMIPaidProof)" :href="PhotoPreviewUrl" target="_blank" class="btn btn-sm btn-outline-primary mt-1">
                      <i class="fa fa-eye"></i> View Selected File
                    </a>
                  </div>
                  <div
                    class="col-md-4"
                    v-if="form.UploadEMIPaidProof !='' && form.UploadEMIPaidProof"
                  >
                    <a :href="getImgUrl2(form.UploadEMIPaidProof)" target="_blank">
                      <img
                        style="height:30px"
                        :src="getImgUrl(form.UploadEMIPaidProof)"
                        class="img-fluid"
                      />
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('UploadEMIPaidProof', form.UploadEMIPaidProof)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                      v-if="!LockProfile"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <span class="ln-eng" style="font-size: 0.875rem;">Latest Business Photo *</span>
                    <p
                      style="font-size: 0.75rem;color:#2284ab;"
                    >Upload Latest Photo of Business for which Loan Sanctioned</p>
                  </div>
                  <div class="col-md-4">
                    <b-form-file
                      ref="fiBusinessPath"
                      @change="onFileChangeB"
                      v-if="form.UploadBusinessPhoto =='' || !form.UploadBusinessPhoto"
                      accept=".jpg, .png, .gif, .pdf"
                      size="sm"
                      required
                      class="mt-3"
                      plain
                    ></b-form-file>
                    <a v-if="BusinessPhotoPreviewUrl && (form.UploadBusinessPhoto =='' || !form.UploadBusinessPhoto)" :href="BusinessPhotoPreviewUrl" target="_blank" class="btn btn-sm btn-outline-primary mt-1">
                      <i class="fa fa-eye"></i> View Selected File
                    </a>
                  </div>
                  <div
                    class="col-md-4"
                    v-if="form.UploadBusinessPhoto !='' && form.UploadBusinessPhoto"
                  >
                    <a :href="getImgUrl2(form.UploadBusinessPhoto)" target="_blank">
                      <img
                        style="height:30px"
                        :src="getImgUrl(form.UploadBusinessPhoto)"
                        class="img-fluid"
                      />
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('UploadBusinessPhoto', form.UploadBusinessPhoto)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                      v-if="!LockProfile"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2 justify-content-md-center" v-if="!getUserData.LockProfile">
            <b-col md="4" sm="12" style="text-align:center">
              <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
              <b-alert
                :show="showDismissibleAlert"
                dismissible
                @dismissed="showDismissibleAlert=false"
                :variant="variant"
              >{{alertText}}</b-alert>
            </b-col>
            <b-col sm="12" style="text-align:right">
              <b-button
                v-if="!saved"
                type="submit"
                style="float:right"
                class="ml-3"
                variant="primary"
              >Submit</b-button>
              <b-button v-if="!saved" type="reset" style="float:right" variant="danger">Reset</b-button>
              <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
import common from "@/apis/common";

export default {
  components: { Spinner },
  data() {
    return {
      emiList: [],
      fields: [
        { key: "SL", label: "Sr No" },
        { key: "EMIDate", label: "Month", formatter: "convertDateFormat" },
        { key: "EMIAmount", label: "EMI" },
        { key: "OpeningBalance", label: "Opening Amount" },
        { key: "PrincipalAmount", label: "Principal" },
        { key: "InterestAmount", label: "Interest" },
        { key: "ClosingBalance", label: "Balance" },
        { key: "selected", label: "Claim" }
      ],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions: [50,60,100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      minAmount: 10000,
      maxAmount: 1000000,
      Photo: "",
      PhotoPreviewUrl: null,
      BusinessPhoto:"",
      BusinessPhotoPreviewUrl: null,
      form: {
        ClaimEMIID: "00000000-0000-0000-0000-000000000000",
        EMISheduledID: "00000000-0000-0000-0000-000000000000",
        UserID: "",
        EMIPaidDate: null,
        EMIPaidAmt: 0,
        PrincipalAmt: 0,
        InterestAmt: 0,
        PenaltyCharges: 0,
        UploadBankStmt: "",
        UploadEMIPaidProof: "",
        ClaimStatus: 1,
        ClaimPaidStatus: 1,
        UpdatedBy: "",
        EmiScheduleIds: [],
        UploadBusinessPhoto:""
      },
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0
      },
      LockProfile: false,
      saved: false,
      LockProfile: false,
      dt: null,
      TotalDisbursementAmount: 0,
      selected: [],
      editClaimId: null,
      modalInfo: "",
      selecteObj: { Document: "", Path: "" }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    columnTotals() {
      return this.emiList.reduce((acc, row) => {
        acc.EMIAmount = (acc.EMIAmount || 0) + (Number(row.EMIAmount) || 0);
        acc.PrincipalAmount = (acc.PrincipalAmount || 0) + (Number(row.PrincipalAmount) || 0);
        acc.InterestAmount = (acc.InterestAmount || 0) + (Number(row.InterestAmount) || 0);
        return acc;
      }, {});
    }
  },
  methods: {
    fmtNum(val) {
      return (Number(val) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    selectClaim(checked, index, item) {
      //console.log('item',item);
      if (checked) {
        this.form.InterestAmt += item.InterestAmount;
        this.form.PrincipalAmt += item.PrincipalAmount;
        this.form.EMIPaidAmt += item.EMIAmount;
        this.form.EmiScheduleIds.push(item);
      } else {
        this.form.InterestAmt -= item.InterestAmount;
        this.form.PrincipalAmt -= item.PrincipalAmount;
        this.form.EMIPaidAmt -= item.EMIAmount;
        _.remove(this.form.EmiScheduleIds, function(n) {
          return n.EMIScheduleID == item.EMIScheduleID;
        });
      }
      //console.log('target',this.form.EmiScheduleIds);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(items) {
      this.selected = items;
      let int = 0;
      let prnc = 0;
      let emi = 0;
      this.form.EmiScheduleIds = [];

      for (var i = 0; i < this.selected.length; i++) {
        //loop through the array
        int += this.selected[i].InterestAmount; //Do the math!
        prnc += this.selected[i].PrincipalAmount;
        emi += this.selected[i].EMIAmount;
        this.form.EmiScheduleIds.push(this.selected[i]);
      }
      this.form.EMISheduledID = this.selected[0].EMIScheduleID;
      this.form.InterestAmt = int;
      // this.selected.reduce(function(sum, rw) {
      //   return sum + rw.InterestAmount;
      // }, 0);

      this.form.PrincipalAmt = prnc;
      // this.selected.reduce(function(sum, rw) {
      //   return sum + rw.PrincipalAmount;
      // }, 0);

      this.form.EMIPaidAmt = emi;
      // this.selected.reduce(function(sum, rw) {
      //   return sum + rw.EMIAmount;
      // }, 0);
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        LoanDisbursementID: "00000000-0000-0000-0000-000000000000",
        LoanSanctionID: "",
        UpdatedBy: "",
        DisbursalDate: null,
        EmiStartDate: null,
        EmiEndDate: null,
        VerifiedStatus: 1,
        TrancheNo: "",
        UpdatedDate: null,
        SeparateTenure: false,
        DisburmentAmount: 0,
        EmiAmount: 0,
        HOApprovedAmount: 0,
        UploadEMIPaidProof: "",
        UploadBankStatement: "",
        UploadBusinessPhoto:"",
      };
      this.Photo="";
      this.BusinessPhoto="";
    },
    onClickButton(evt) {
      evt.preventDefault();
      this.$router.push("/claims");
    },
    toInputDate(inDate) {
      if (!inDate) return null;
      var d = new Date(inDate);
      if (isNaN(d.getTime())) return null;
      var month = ("0" + (d.getMonth() + 1)).slice(-2);
      var day = ("0" + d.getDate()).slice(-2);
      return d.getFullYear() + "-" + month + "-" + day;
    },
    async loadClaimForEdit(claimId) {
      if (!claimId) return;

      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.readClaims(userinfo.UserId);

      try {
        let response = await promise;
        if (response.status !== 200 || !Array.isArray(response.body)) {
          return;
        }

        let claim = response.body.find((c) => c.ClaimEMIID === claimId);
        if (!claim) {
          return;
        }

        this.form.ClaimEMIID = claim.ClaimEMIID || this.form.ClaimEMIID;
        this.form.EMISheduledID = claim.EMISheduledID || this.form.EMISheduledID;
        this.form.EMIPaidDate = this.toInputDate(claim.EMIPaidDate) || this.form.EMIPaidDate;
        this.form.EMIPaidAmt = Number(claim.EMIPaidAmt) || 0;
        this.form.PrincipalAmt = Number(claim.PrincipalAmt) || 0;
        this.form.InterestAmt = Number(claim.InterestAmt) || 0;
        this.form.PenaltyCharges = Number(claim.PenaltyCharges) || 0;
        this.form.UploadEMIPaidProof = claim.UploadEMIPaidProof || "";
        this.form.UploadBusinessPhoto = claim.UploadBusinessPhoto || "";

        // Re-submit should move claim back into approval flow.
        this.form.ClaimStatus = 1;
        this.form.ClaimPaidStatus = 1;

        if (this.form.EMISheduledID) {
          this.form.EmiScheduleIds = [{ EMIScheduleID: this.form.EMISheduledID }];
        }
      } catch (err) {
        // Non-blocking: user can still submit a fresh claim.
      }
    },
    async onSubmit(evt) {
      evt.preventDefault();
      if (
        Number(this.form.EMIPaidAmt) <
        Number(this.form.PrincipalAmt) +
          Number(this.form.InterestAmt) +
          Number(this.form.PenaltyCharges)
      ) {
        this.alertText =
          "EMI Amount can't be less than Addition of Principal, Interest and Charges.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }

      if (
        this.form.EmiScheduleIds.length == 0 ||
        Number(this.form.PrincipalAmt) + Number(this.form.InterestAmt) <= 0
      ) {
        this.alertText = "Please select EMIs to be paid from table.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        return;
      }

      this.showDismissibleAlert = false;
      this.isLoading = true;

      var d = new Date();
      let response = null;

      if (this.Photo && this.Photo.length > 0) {
        response = await common.onFileChange(
          this.Photo,
          "ClaimProof" + d * 1 + "."
        );

        if (response.status) {
          this.form.UploadEMIPaidProof = response.message;
        } else {
          this.$refs.fiPhotoPath.reset();
          this.alertText = response.message;
          this.variant = "danger";
          this.showDismissibleAlert = true;
          this.isLoading = false;
          return;
        }
      }

      if (!this.form.UploadEMIPaidProof) {
        this.alertText = "Please upload EMI Payment Proof.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      if (this.BusinessPhoto && this.BusinessPhoto.length > 0) {
        response = await common.onFileChange(
          this.BusinessPhoto,
          "BusinessPhoto" + d * 1 + "."
        );

        if (response.status) {
          this.form.UploadBusinessPhoto = response.message;
        } else {
          this.$refs.fiBusinessPath.reset();
          this.alertText = response.message;
          this.variant = "danger";
          this.showDismissibleAlert = true;
          this.isLoading = false;
          return;
        }
      }

      if (!this.form.UploadBusinessPhoto) {
        this.alertText = "Please upload Latest Business Photo.";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      var userinfo = this.$store.getters.loggedUser;
      this.form.UpdatedBy = userinfo.UserId;
      this.form.UserID = userinfo.UserId;
      this.form.LoanSanctionID = this.LoanDetails.LoanSanctionID;

      let promise = apis.saveClaim(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            //to add - Claim Total Value and Row Locking.
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getUserData() {},
    async onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.Photo = files;
      if (files && files.length > 0) {
        this.PhotoPreviewUrl = URL.createObjectURL(files[0]);
      } else {
        this.PhotoPreviewUrl = null;
      }
    },
    async onFileChangeB(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.BusinessPhoto = files;
      if (files && files.length > 0) {
        this.BusinessPhotoPreviewUrl = URL.createObjectURL(files[0]);
      } else {
        this.BusinessPhotoPreviewUrl = null;
      }
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      this.form.UpdatedBy = userinfo.UserId;
      this.form.UserID = userinfo.UserId;
      let promise = apis.saveClaim(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Document removed Successfully.";
            this.showDismissibleAlert = true;
            this.variant = "success";
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    deleteDocument2(document, path) {
      //console.log(item);
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic
        );
      }
    },

    getSanctionLetterDetails() {
      let userid = this.$store.getters.loggedUser.UserId;

      let promise = apis.ReadSanctionLetterByUserID(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.LoanDetails = response.body;
            this.$store.dispatch("setSanctionLetter", this.LoanDetails);
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    getEMIList() {
      let applicationid = this.$store.getters.getApplicationID;

      let promise = apis.getSehedule(applicationid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.emiList = response.body;
            this.totalRows=response.body.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.editClaimId = this.$route.query && this.$route.query.claimId
      ? this.$route.query.claimId
      : null;
    this.getSanctionLetterDetails();
    this.getEMIList();
    if (this.editClaimId) {
      this.loadClaimForEdit(this.editClaimId);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimUpload/UploadClaim.vue